import { getRules, getMultiComplexRules } from './rules'
import Input from '../components/FormControl/Input'
import InputTime from '../components/FormControl/InputTime'
import InputTaoSirForm from '../components/FormControl/InputTaoSirForm'
import Checkbox from '../components/Checkbox'
import SingleCheck from '../components/Checkbox/SingleCheck'
import Radio from '../components/Radio'
import MultiComplexItem from '../components/MultiComplexItem/index.vue'
import ComplexItem from '../components/ComplexItem'
import ShoppingTitle from '../components/ComplexItem/ShoppingTitle'
import CatProp from '../components/ComplexItem/CatProp'
import Specification from '../components/ComplexItem/Specification'
import Images from '../components/ComplexItem/Images'
import GroupImages from '../components/ComplexItem/GroupImages'
import Image from '../components/Upload/Image'
import Select from '../components/Select'
import Editor from '../components/Editor'
import ShopCat from '../components/ComplexItem/Shopcat'
import store from '@/store'
import { genIsShowFn } from './disableRule'
import VideoUploadWithTag from '../components/ComplexItem/VideoUploadWithTag.vue'

// 生产次级属性需要的props
function _genSecondaryProps(item) {
    if (/\[alibaba.item.publish.props.get\]/.test(item?._oriRules?.devTipRule)) {
        const { name, label, type, _fieldDescriptor = [] } = item;
        return {
            secondary: true,
            _genFieldDescriptor: function(val = '') {
                return {
                    "name":"catProp",
                    "label":"类目属性",
                    "type":"COMPLEX",
                    children: [
                        ..._fieldDescriptor,
                        {
                            name,
                            label,
                            "defaultValue": val,
                            type
                        }
                    ]
                }
            },
        }
    } else {
        return {}
    }
}

// 采购地的isShowFn
function _globalStockShowFn(tbForm) {
    return tbForm.globalStockNav === '1'
}
// 发货时间天数的isShowFn
function _tbDeliveryTimeShowFn(tbForm) {
    return tbForm.deliveryTimeType === '2'
}
// 发货时间天数的isShowFn
function _deliveryTimeSetBySkuShowFn(tbForm) {
    return tbForm.deliveryTimeType === '2' && window._globel_vm?.$store.getters.tbData?.pureType !== 1
}


export let needLimitImgFields = ['images', 'verticalImage', 'threeToFourImages'];
// 一些图片的限制生成
function _genImagesLimit(item) {
    if (!needLimitImgFields.includes(item.name)) {
        return {}
    }
    // 生成符合图片上传组件适用的属性
    let limits = {
        limitWidth: [0, 0],
        limitHeight: [0, 0]
    }
    let {maxTargetSizeRule, maxImageSizeRule, minImageSizeRule, tipRule} = item._oriRules || {}
    if (maxTargetSizeRule) {
        limits.limitSize = Number(maxTargetSizeRule)
        limits._needLimit = true;
    }
    if (maxImageSizeRule) {
        let maxS = maxImageSizeRule.split('x')
        limits.limitHeight[1] = maxS[1]
        limits.limitWidth[1] = maxS[0]
        limits._needLimit = true;
    }
    if (minImageSizeRule) {
        let minS = minImageSizeRule.split('x')
        limits.limitHeight[0] = minS[1]
        limits.limitWidth[0] = minS[0]
        limits._needLimit = true;
    }
    if (tipRule) {
        // 有些图片限制需要通过tipRule描述，如比例
        // 一些正则匹配
        let regAspectRatio = /横竖比必须为(\d+：\d+)/
        let regAspectRatio1 = /比例为(\d+:\d+)/

        // 匹配比例 
        let aspectRatio = tipRule.match(regAspectRatio) || tipRule.match(regAspectRatio1);
        if (aspectRatio) {
            aspectRatio = aspectRatio[1];
            let _asp = aspectRatio.includes(':') ? aspectRatio.split(':') :aspectRatio.split('：')
            limits.aspectRatio = _asp[0] / _asp[1]
            limits.aspectRatioText = aspectRatio
            limits._needLimit = true;
        }

        // 匹配最小宽度
        let regMinWidth = /最小长度为(\d+)/
        let minWidth = tipRule.match(regMinWidth)
        if (minWidth) {
            minWidth = minWidth[1]
            limits.limitWidth[0] = minWidth
            limits._needLimit = true;
        }

    }
    if(item.name === 'images') {
        limits.aspectRatio = 1
        limits.aspectRatioText = '1:1'
        limits.limitSize = 3 * 1024 * 1024;
        limits._needLimit = true;
        limits.supportAiRetry = true;
        limits.autoCropImageParams={publishAutoCropImageEnum:'TB_MainImg'}
    } 
    if(item.name === 'threeToFourImages') {
        limits.aspectRatio = 0.75
        limits.aspectRatioText = '3:4'
        limits.limitSize = 3 * 1024 * 1024;
        limits._needLimit = true;
        limits.autoCropImageParams={publishAutoCropImageEnum:'TB_MainImg34'}
    } 
    if(item.name === 'verticalImage') {
        limits.autoCropImageParams={publishAutoCropImageEnum:'TM_VerticalImage'}
    }
    // 铺货配置，图片修正规则，做了配置就不需要做校验了，后端会自动修正比例和尺寸大小
    const autoCropImageConfigList = (localStorage.getItem('autoCropImageConfigList') || '').split(',');
    const imagekeyConfMap = {
        images: 'mainImg',
        threeToFourImages: 'mainImg34',
    }
    if(autoCropImageConfigList.includes(imagekeyConfMap[item.name] || item.name)) {
        delete limits.aspectRatio;
        delete limits.aspectRatioText;
        delete limits.limitWidth;
        delete limits.limitHeight;
        delete limits.limitSize;
    }
    return limits
}

const useGenIsShowFns = [
    'legalCustoms',
    // 'food_security.food_nutrition_table',
    // 'food_security.organic_food',
    'food_security.organic_certification',
    // 'food_security.is_green_food',
    'food_security.green_food_level',
    'food_security.green_food_produce_number',
]
// 一些表单控件的展现需要依赖另一些 （生成isShowFn方法)
// 有些控件的提示语需要根据值来渲染 （生产isShowTipFn方法)
function _genIsShowFn(item) {
    if (item.name === "globalStock") {
        // 采购地的一些字段处理
        item.children.forEach(child => {
            if (["country", "stockType"].includes(child.name)) {
                child.isShowFn = _globalStockShowFn
            }
        })
    } else if (item.name === "departurePlace") {
        // 发货地也要依据采购地的isShowFn来展示
        item.isShowFn = _globalStockShowFn
    } else if (useGenIsShowFns.includes(item.name)) {
        let legalCustomsShowFnObj = {
            rules: { disableRule: item._oriRules?.disableRule }
        }
        genIsShowFn(legalCustomsShowFnObj)
        if (legalCustomsShowFnObj.isShowFn) {
            item.isShowFn = legalCustomsShowFnObj.isShowFn
        }
    } else if (["tbDeliveryTime"].includes(item.name)) {
        item._preText = `付款后`
        item._suffixText = `天内发货<span style="margin-left: 5px;" class="tips">(按商品规格设置不生效时，将按款维度发货时间铺货)</span>`
        item.isShowFn = _tbDeliveryTimeShowFn
    } else if (item.name === "deliveryTimeSetBySku") {
        item.isShowFn = _deliveryTimeSetBySkuShowFn
    } else if (item.name === "deliveryTimeType") {
        item.isShowTipFn = (form) => {
            return ["0", "3"].includes(form.deliveryTimeType)
        }
        // 产品文档需要把大于48小时发货改为全款预售
        let item48 = item.options.find(item => item.displayName === "大于48小时发货" && item.value === "2")
        if (item48) {
            item48.warning = "平台指定类目才有该权限，若类目无权限将禁用该项"
        }
    }
    return item
}

/**
 * 是否用 checkbox 组件
 * @param {*} item 
 * @returns 
 */
const isCheckbox = (item) => {
    const { name, options } = item
    if (options.length === 2) {
        const isTrue = options.some(item => (item.value === '1' || item.value === 'true') && item.displayName === '是') && 
            options.some(item => (item.value === '0' || item.value === 'false') && item.displayName === '否') && !item.rules.some(item => item.required)
        return isTrue;
    }
}
const editorImageAttrs = (item) => {
    let extraAttr = {}
    if(item.name === 'desc') {
        extraAttr = {
            limitSize: 10 * 1024 * 1024,
            limitWidth: [0, 10000],
            limitHeight: [0, 10000],
            limitNums: 50,
        }
    } else if(item.name === 'wirelessDesc') {
        const tbIsNew = store.getters.tbIsNew;
        const autoCropImageConfigList = (localStorage.getItem('autoCropImageConfigList') || '').split(',');
        extraAttr = {
            limitSize: 10 * 1024 * 1024,
            limitWidth: tbIsNew && !autoCropImageConfigList.includes('wirelessDesc') ? [480, 1500] : [0, 0],
            limitHeight: tbIsNew && !autoCropImageConfigList.includes('wirelessDesc') ? [0, 2000] : [0, 0],
            limitNums: 50,
            limitSuffix: '.jpg,.jpeg,.png',
            mainImgNums: 0
        }
    }
    return extraAttr
}

const typeMap = {
    // INPUT，说明当前field的值为文本输入型。
    INPUT: item => {
        const { properties, name, parentName, _oriRules } = item
        const { valueTypeRule } = _oriRules || {}
        // 特殊处理
        // name 为 "desc" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["desc", "wirelessDesc"].includes(name)) {
            return {
                component: Editor,
                props: {dataSource: item, name, parentName, extraAttr: editorImageAttrs(item)} 
            }
        }

        if (Array.isArray(properties) && properties.length > 0) {
            if(properties[0].type === 'taoSirProperty') { // 判断是否为度量衡属性
                return {
                    component: InputTaoSirForm,
                    props: { dataSource: item, name, parentName }
                }
            } else {
                return {
                    component: Input,
                    props: { dataSource: item, name, parentName }
                }
            }
          
        } else if (valueTypeRule === 'decimal') {
            return {
                component: Input,
                props: { min: 0, precision: 2, name, parentName }
            }
        } else if (valueTypeRule === 'integer') {
            return { component: Input, props: { min: 1, precision: 0, name, parentName } }
        } else if (valueTypeRule === 'url') {
            return {
                component: Image,
                props: {name, parentName}
            }
        } else if (valueTypeRule === 'date') {
            return {
                component: InputTime,
                props: {
                    'time-type': 'date',
                    'value-format': 'YYYY-MM-DD',
                    'date-picker-format': 'YYYY-MM-DD',
                    name,
                    parentName
                }
            }
        } else if (valueTypeRule === 'time') {
            return {
                component: InputTime,
                props: {
                    'time-type': 'datetime',
                    'value-format': 'YYYY-MM-DD HH:mm:ss',
                    'date-picker-formatt': 'YYYY-MM-DD HH:mm:ss',
                    'date-width': '180px',
                    'default-time': ['00:00:00', '23:59:59'],
                    name,
                    parentName
                }
            }
        } else {
            return {
                component: Input,
                props: {
                    dataSource: _genIsShowFn(item),
                    placeholder: '请输入',
                    name,
                    parentName,
                    append: item._oriRules.unitTypeRule,
                    maxLengthRule: item._oriRules.maxLengthRule
                },
            }
        }
    },
    // MULTIINPUT ，说明当前field的值为多行文本输入型。
    MULTIINPUT: item => {
        const { name } = item
        return { component: Input, props: { name } }
    },
    // SINGLECHECK，说明当前field的值为单选输入型，类似于radio。
    SINGLECHECK: item => {
        const { options, name, parentName, tipRule } = item
        if(name === 'startTime') {
            item.options = options.filter(op => op.value != 1);  // 去除定时上架，暂不支持 
            if (tipRule && tipRule.length) {
                item.tipRule = tipRule.filter(tr => tr !== '定时上架的商品在上架前请到“仓库中的宝贝”里编辑商品。');
            }
        }
        if (parentName && parentName === 'catProp') {
            let canInputCustom = false
            if (tipRule && tipRule.includes("该属性支持自定义输入，自定义输入值请填写至value标签inputValue属性, value标签内容为任意负数")) {
                canInputCustom = true
            }
            let secondaryProp = _genSecondaryProps(item);
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, name, "value-key": "value", style: "width:100%;", canInputCustom, clearNoExistValue: true, ...secondaryProp } }
        } else if (isCheckbox(item)) {
            return { component: SingleCheck, props: {dataSource: _genIsShowFn(item), name, label: 's'}}
        }
        else if (options.length <= 3 && name !== 'catProp' || item.source === 'saleProp') {
            return { component: Radio, props: { dataSource: _genIsShowFn(item), name } }
        }
        else {
            return { component: Select, props: { dataSource: _genIsShowFn(item), name } }
        }
    },
    // MULTICHECK ，说明当前field的值为多选输入型，类似于checkbox。
    MULTICHECK: item => {
        const { options, name, parentName, tipRule } = item
        if (parentName && parentName === 'catProp') {
            let canInputCustom = false
            if (tipRule && tipRule.includes("该属性支持自定义输入，自定义输入值请填写至value标签中inputValue属性,value标签内容为任意负数；多个输入值请保证value中内容负数值不重复")) {
                canInputCustom = true
            }
            let secondaryProp = _genSecondaryProps(item);
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, multiple: true, name, "value-key": "value", style: "width:100%;", canInputCustom, clearNoExistValue: true, ...secondaryProp } }
        } else if(name === 'shopcat'){
            return { component: ShopCat, props: { dataSource: item, name } }
        }else{
            return { component: Select, props: { dataSource: item, multiple: true, name } }
        }
    },
    // COMPLEX ，说明当前field的值为复合结构，表示数据的聚合。
    COMPLEX: item => {
        const { name, parentName } = item
        // 特殊处理几种复合型控件
        // 0. ShoppingTitle 为导购标题
        // 1. catProp 为类目属性
        // 2. saleProp 为销售属性（同其他平台的规格信息）
        // 3. images 为主图+宝贝图+白底图（同其他主图组件，至于区分主图、宝贝图、白底图交由后端发布时后端处理）
        // 4. verticalImage 为长图，也用images的组件，在组件里作name的区别判断
        const specialCompMap = {
            "shopping_title": ShoppingTitle,
            "catProp": CatProp,
            "saleProp": Specification,
            "images": Images,
            "verticalImage": Images,
            "threeToFourImages": Images,
            "useGroupImages": GroupImages,
        }
        // 特殊处理
        // name 为 "desc" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["desc", "wirelessDesc"].includes(name)) {
            return {
                component: Editor,
                props: {dataSource: item, name, parentName, extraAttr: editorImageAttrs(item)}
            }
        }
        const otherParams = {};
        let imgAttr = {};
        if (name === 'saleProp') {
            imgAttr = item.imgRules || {};
        }

        if (name === 'threeToFourImages') {
            otherParams['cropDefaultSize'] = [750, 1000];
        }
        if (name === 'verticalImage') {
            otherParams['limitNums'] = 1;
        }
        if (name === 'shopping_title') {
            delete item.tipRule
        }
        
        if (needLimitImgFields.includes(name)) {
            otherParams['showAuditResult'] = true;
        }
        return {
            component: specialCompMap[name] || ComplexItem,
            props: {
                dataSource: _genIsShowFn(item),
                parentName,
                name,
                imgAttr,
                extraAttr: {
                    ..._genImagesLimit(item),
                    ...otherParams,
                },
            }
        }
    },
    // MULTICOMPLEX ，说明当前field的值为复合结构，与complex有差别的在于multiComplex的field是可以有多份数据实例样本。
    MULTICOMPLEX: item => {
        const { name } = item
           // 特殊处理几种复合型控件
           // 1. VideoUploadWithTag 为视频，
        const specialMultiCompMap = {
            "auctionVideos": VideoUploadWithTag,
        }
        let multiple = name === 'auctionVideos'
        return { component: specialMultiCompMap[name] || MultiComplexItem, props: { dataSource: item, name,multiple } }
    }
}

/**
 * 生成field
 * @param {*} fields 
 * @returns 
 */
const generateField = (fields, parentName) => {
    return fields.reduce((field, item) => {
        // 暂时屏蔽非类目属性下的多实例符合类型
        // if (item.type === 'MULTICOMPLEX' && parentName !== 'catProp') {
        //     return field
        // }

        if(item.type === 'COMPLEX' && item.name !== 'useGroupImages') {
            if(!item.children?.length) return field
        }
        if (item.children) {
            item.children = generateField(item.children, item.name)
        }
        parentName && (item.parentName = parentName)
        if(item.type === "MULTICOMPLEX" && item.name === "auctionVideos"){
            item.tips = item.rules
        }
        item.rules = item.type === 'MULTICOMPLEX' ? getMultiComplexRules(item)  : getRules(item) // rule
        item.component = typeMap[item.type](item)
        if (item.name === 'quantity') {
            // // 纯商品需要放开总数量
            // let initTbDetail = store.state.tbForm.form;
            // // 总数量需要禁用输入，值通过skuList中的skuStock 求合得来
            // if(initTbDetail && initTbDetail.pureType) {
            //     item.component.props.disabled = false;
            // } else {
            //     item.component.props.disabled = true;
            // }
            // 且需要给予提示语
            item.tipRule = item.tipRule && (item.tipRule instanceof Array) ? item.tipRule.push('此处是商品所有销售规格总库存数量, 若需修改请在商品明细表格内修改对应库存')
            : ['此处是商品所有销售规格总库存数量, 若需修改请在商品明细表格内修改对应库存']
        }
        return field.concat(item)
    }, [])
}


/**
 * 获取field
 * @param {*} fields 
 * @returns 
 */
export const getField = (fields) => {
    if (!Array.isArray(fields) || fields.length <= 0) return []
    return generateField(fields)
}